/*jshint browserify: true */
'use strict';

module.exports = [0.5, 0.75, 1.0, 1.25, 1.5, 2.0, 3.0, 4.0, 5.0];